import { render, staticRenderFns } from "./AnomalySummaryBase.vue?vue&type=template&id=e2c19698&scoped=true&"
import script from "./AnomalySummaryBase.vue?vue&type=script&lang=js&"
export * from "./AnomalySummaryBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c19698",
  null
  
)

export default component.exports